import { SET_TAB_LAYERS_FILTER } from 'drawer/tabs/layers/search/actions'

export const tabLayersFilter = (state = null, action) => {
  switch (action.type) {
    case SET_TAB_LAYERS_FILTER:
      return action.tabLayersFilter
    default:
      return state
  }
}
